import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { CLIENT_DOCUMENT_REQUEST_SEARCH_START_LOADING, CLIENT_DOCUMENT_REQUEST_SEARCH_END_LOADING, CLIENT_DOCUMENT_REQUEST_SEARCH_LOADED, SET_CLIENT_DOCUMENT_REQUEST_FILTER } from "../constants/ClientDocumentRequestConstants";
import { CLIENT_DOCUMENT_REQUEST_START_LOADING, CLIENT_DOCUMENT_REQUEST_END_LOADING, CLIENT_DOCUMENT_REQUEST_LOADED } from "../constants/ClientDocumentRequestConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        sortBy: "request_number",
        sortOrder: "DESC"
    },
    loadingFBO: false,
    fbo: null,
};

const ClientDocumentRequestReducer = (state = initialState, action) => {
    switch(action.type) {
        case CLIENT_DOCUMENT_REQUEST_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case CLIENT_DOCUMENT_REQUEST_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case CLIENT_DOCUMENT_REQUEST_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_CLIENT_DOCUMENT_REQUEST_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case CLIENT_DOCUMENT_REQUEST_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case CLIENT_DOCUMENT_REQUEST_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case CLIENT_DOCUMENT_REQUEST_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default ClientDocumentRequestReducer;